import React, { useRef } from 'react'
import './Leadership.css';

import shreya from './images/Leadership/2022-2023/Shreya.jpg';
import manasa from './images/Leadership/2022-2023/Manasa.jpeg';
import isha from './images/Leadership/2022-2023/Isha.jpeg';
import shrima from './images/Leadership/2022-2023/Shrima.jpeg';
import jeewon from './images/Leadership/2022-2023/Jeewon.jpg';
import athena from './images/Leadership/2022-2023/Athena (1).jpg';
import chi from './images/Leadership/2022-2023/Chi (1).jpeg';
import arya from './images/Leadership/2022-2023/Arya.jpeg';

import {BsFacebook, BsDiscord} from 'react-icons/bs'
import {RiInstagramFill} from 'react-icons/ri'

const Leadership = () => {
  const ref = useRef(null);
  return (
    <><div>
      <div>
        <div>
          <div className='teamTitle-wrapper'>
            <p id="teamTitle">Officers 2024 - 2025</p>
          </div>
        </div>
        <div class="members">

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={shreya} alt="Shreya Sathyanarayanan" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Shreya Sathyanarayanan</b>
              </h4>
              <p class='role'>Chair</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={manasa} alt="Manasa Lingireddy" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Manasa Lingireddy</b>
              </h4>
              <p class='role'>Vice Chair</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={isha} alt="Isha Jagadish" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Isha Jagadish</b>
              </h4>
              <p class='role'>Secretary/Treasurer</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={shrima} alt="Shrima Narasimhan" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Shrima Narasimhan</b>
              </h4>
              <p class='role'>Student Relations</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={jeewon} alt="Jeewon Jung" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Jeewon Jung</b>
              </h4>
              <p class='role'>Public Relations</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={athena} alt="Athena Bao" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Athena Bao</b>
              </h4>
              <p class='role'>Social Media Director</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={chi} alt="Chi Dang"/>
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Chi Dang</b>
              </h4>
              <p class='role'>Social Events Committee Head</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={arya} alt="Arya Sanjay" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Arya Sanjay</b>
              </h4>
              <p class='role'>Outreach Committee Head</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

        </div>

      </div>
    </div>
    <div className='actions' ref={ref}>
    <div className='action-description'>
          <p ><strong>Not a  WiC member?</strong></p>
          <p>Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' class='footerLink'>here</a> and sign up for 
          our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank'  class='footerLink'>mailing list</a> to 
          get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!</p>
        </div>
         <br></br>
        <div className='socials'>
          <a id='insta' href='https://www.instagram.com/uw.wic/' target='_blank' rel="noreferrer"><RiInstagramFill /></a>
          <a id='fbook' href='https://www.facebook.com/uwwic' target='_blank' rel="noreferrer"><BsFacebook /></a>
          <a id='discord' href='https://discord.gg/Zp4GVB7ddq' target='_blank' rel="noreferrer"><BsDiscord /></a>
        </div>
        <div className='wicEmail'>
          <a href="mailto:wic-officers@cs.washington.edu" class='footerLink'>wic-officers@cs.washington.edu</a>
        </div>
    </div></>
  )
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Leadership;
